import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

import { Evento, EventoMenu, EventoProduto, EventoProdutoEvento, FormaPagamento } from './models/evento';
import { Fornecedor } from '../fornecedor/models/fornecedor';
import { PedidoEvento } from '../pedido/models/pedido';
import { tap } from 'rxjs/operators';


@Injectable({
    providedIn: 'root'
})

export class EventoService {

    private environmentUrl: string = '';
    private eventoSubject = new BehaviorSubject<EventoMenu>(null);

    constructor(private httpClient: HttpClient) { this.environmentUrl = environment.ApiCore; }

    getEventos(): Observable<Evento[]> {
        let url = this.environmentUrl + "/evento/";
        return this.httpClient.get<Evento[]>(url);
    }

    getEventosAbertos(): Observable<Evento[]> {
        let url = this.environmentUrl + "/evento/abertos";
        return this.httpClient.get<Evento[]>(url);
    }

    getEventosAbertosMenu(){
        return this.eventoSubject.asObservable();
    }

    setEventoAbeto(evento){
        this.eventoSubject.next(evento);
    }

    getEventosAbertos2(){
        let url = this.environmentUrl + "/evento/";
        return this.httpClient
          .get(
            url,
            {observe: 'response'}
          )
          .pipe(tap(res=>{

            this.setEventoAbeto(res);
            
          }))
          ;
  
      }

    getEvento(idEvento: number): Observable<Evento> {
        let url = this.environmentUrl + "/evento/" + idEvento;
        return this.httpClient.get<Evento>(url);
    }

    addEvento(Evento: Evento) {
        return this.httpClient.post(this.environmentUrl + "/evento", Evento);
    }

    updEvento(Evento: Evento) {
        return this.httpClient.put(this.environmentUrl + "/evento", Evento);
    }

    delEvento(idEvento: number) {
        return this.httpClient.delete(this.environmentUrl + "/evento/" + idEvento);
    }

    getEventoProdutos(idEvento: number): Observable<EventoProdutoEvento[]> {
        return this.httpClient.get<EventoProdutoEvento[]>(this.environmentUrl + "/eventoproduto/evento/" + idEvento);
    }

    addEventoProduto(eventoProduto: EventoProduto) {
        return this.httpClient.post(this.environmentUrl + "/eventoProduto", eventoProduto);
    }

    updEventoProduto(eventoProduto: EventoProduto) {
        return this.httpClient.put(this.environmentUrl + "/eventoProduto", eventoProduto);
    }

    updEventoProdutoEstoque(eventoProduto: EventoProduto) {
        return this.httpClient.put(this.environmentUrl + "/eventoProduto/estoque", eventoProduto);
    }

    delEventoProduto(idEventoProduto: number) {
        return this.httpClient.delete(this.environmentUrl + "/eventoProduto/" + idEventoProduto);
    }

    getFornecedores(idEvento: string): Observable<Fornecedor[]> {
        return this.httpClient.get<Fornecedor[]>(this.environmentUrl + "/EventoFornecedor/Evento/" + idEvento);
    }
    getFornecedoresUsuario(idUsuario: string): Observable<Fornecedor[]> {
        return this.httpClient.get<Fornecedor[]>(this.environmentUrl + "/Usuario/Fornecedor/" + idUsuario);
    }

    getFornecedoresUsuarioVinculados(): Observable<Fornecedor[]> {
        return this.httpClient.get<Fornecedor[]>(this.environmentUrl + "/Usuario/Fornecedor/vinculados");
    }

    getProdutosFornecedor(idEventoFornecedor: string): Observable<EventoProdutoEvento[]> {
        return this.httpClient.get<EventoProdutoEvento[]>(this.environmentUrl + "/EventoProduto/EventoFornecedor/" + idEventoFornecedor);
    }
    getFormasPagamentoEvento(): Observable<FormaPagamento[]> {
        return this.httpClient.get<FormaPagamento[]>(this.environmentUrl + "/FormaPagamento/Evento");
    }

    getFormasPagamentoEventoFornecedor(idEventoFornecedor: string): Observable<FormaPagamento[]> {
        return this.httpClient.get<FormaPagamento[]>(this.environmentUrl + "/FormaPagamento/EventoFornecedor/"+idEventoFornecedor);
    }


    getFormasPagamentoEventoForcendor(idEventoFornecedor: number): Observable<FormaPagamento[]> {
        return this.httpClient.get<FormaPagamento[]>(this.environmentUrl + "/FormaPagamento/EventoFornecedor/" + idEventoFornecedor);
    }

    updFornecedorPagamento(selectedFormasPagamento: FormaPagamento[], idEventoFornecedor: number) {        
        return this.httpClient.post(this.environmentUrl + "/EventoFornecedor/FormaPagamento/" + idEventoFornecedor, selectedFormasPagamento);
    }

    addPedido(pedido: PedidoEvento) {
        let url = this.environmentUrl+"/Pedido/Evento";        
        return this.httpClient.post(url, pedido);
    } 
}


